import { useEffect } from 'react'
import architecturalBackground from './assets/login-architecture.jpg'
import LoginAuthForm from './components/LoginAuthForm'
import LoginFooter from './components/LoginFooter'
import LoginSidebar from './components/LoginSidebar'
import SessionResolutionModal from './components/SessionResolutionModal'
import { useLoginScreen } from './hooks/useLoginScreen'

export default function LoginScreen() {
  const {
    tenantUsername,
    identifier,
    password,
    rememberDevice,
    isSubmitting,
    error,
    successMessage,
    setTenantUsername,
    setIdentifier,
    setPassword,
    setRememberDevice,
    handleLoginSubmit,
    handleForgotPasswordClick,
    pendingAgentVerification,
    cancelSessionResolution,
    continueWithSessionResolution,
  } = useLoginScreen()

  useEffect(() => {
    document.body.style.overflow = ''
    document.documentElement.style.overflow = ''
  }, [])

  return (
    <div className="flex min-h-screen flex-col bg-surface text-on-surface">
      <SessionResolutionModal
        isOpen={Boolean(pendingAgentVerification)}
        sessionResolution={pendingAgentVerification?.sessionResolution}
        onReplace={() => continueWithSessionResolution('replace')}
        onCancel={cancelSessionResolution}
      />
      <main className="flex flex-1 items-stretch">
        <LoginSidebar />

        <section className="relative flex flex-1 flex-col">
          <div className="absolute inset-0 z-0 hidden xl:block pointer-events-none overflow-hidden">
            <img
              src={architecturalBackground}
              alt="Monolithic modern skyscraper with geometric glass panels reflecting a clear blue sky."
              className="h-full w-full object-cover opacity-10"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-surface via-transparent to-transparent" />
          </div>

          <div className="relative z-10 flex flex-1 w-full items-center justify-center p-6 sm:p-8 lg:py-12 lg:px-16">
            <LoginAuthForm
              tenantUsername={tenantUsername}
              identifier={identifier}
              password={password}
              rememberDevice={rememberDevice}
              isSubmitting={isSubmitting}
              error={error}
              successMessage={successMessage}
              onTenantUsernameChange={setTenantUsername}
              onIdentifierChange={setIdentifier}
              onPasswordChange={setPassword}
              onRememberDeviceChange={setRememberDevice}
              onLoginSubmit={handleLoginSubmit}
              onForgotPasswordClick={handleForgotPasswordClick}
            />
          </div>
        </section>
      </main>

      <LoginFooter />
    </div>
  )
}
